import React from "react";

const joinClass = (...parts) => parts.filter(Boolean).join(" ");

export const DashCard = ({
  className,
  title,
  headerClassName,
  headerActions,
  children,
}) => (
  <div className={joinClass("card", "dash-card", className)}>
    {title ? (
      <div className={joinClass("dash-card-header", headerClassName)}>
        <span className="dash-card-title">{title}</span>
        {headerActions}
      </div>
    ) : null}
    {children}
  </div>
);
